import "@/App.css";
import { VisorDocumento } from "@/components/visor/VisorDocumento";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import { Layout } from "@/components/Layout";
import Inicio from "@/pages/Inicio";
import Areas from "@/pages/Areas";
import Asuntos from "@/pages/Asuntos";
import Proximos from "@/pages/Proximos";
import Documentos from "@/pages/Documentos";
import Agente from "@/pages/Agente";
import Ocio from "@/pages/Ocio";
import AvisosMovil from "@/pages/AvisosMovil";
import Archivo from "@/pages/Archivo";
import MatterDetail from "@/pages/MatterDetail";
import Familia from "@/pages/Familia";
import AreaView from "@/pages/AreaView";
import Mascotas from "@/pages/Mascotas";
import MascotaDetail from "@/pages/MascotaDetail";
import Viviendas from "@/pages/Viviendas";
import ViviendaDetail from "@/pages/ViviendaDetail";
import Vehiculos from "@/pages/Vehiculos";
import VehiculoDetail from "@/pages/VehiculoDetail";
import Papelera from "@/pages/Papelera";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Perfil from "@/pages/Perfil";
import Correos from "@/pages/Correos";
import Contactos from "@/pages/Contactos";
import AuthCallback from "@/pages/AuthCallback";
import Recuperar from "@/pages/Recuperar";
import Restablecer from "@/pages/Restablecer";
import VerificarEmail from "@/pages/VerificarEmail";
import PersonaDetalle from "@/pages/PersonaDetalle";
import RecordatorioDetalle from "@/pages/RecordatorioDetalle";
import Gestiones from "@/pages/Gestiones";
import Gastos from "@/pages/Gastos";
import Bienvenida from "@/pages/Bienvenida";
import AvisoPrivacidad from "@/pages/AvisoPrivacidad";

const Loader = () => (
  <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center">
    <div className="w-14 h-14 rounded-full border-4 border-[#E5DFD5] border-t-[#3A6B56] animate-spin" />
  </div>
);

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/bienvenida" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppShell() {
  return (
    <ProtectedRoute>
      <DataProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/areas" element={<Areas />} />
            <Route path="/asuntos" element={<Asuntos />} />
            <Route path="/proximos" element={<Navigate to="/agenda" replace />} />
            <Route path="/agenda" element={<Proximos />} />
            <Route path="/gestiones" element={<Gestiones />} />
            <Route path="/gastos" element={<Gastos />} />
            <Route path="/gestiones/:id" element={<RecordatorioDetalle />} />
            <Route path="/documentos" element={<Documentos />} />
            <Route path="/papelera" element={<Papelera />} />
            <Route path="/agente" element={<Agente />} />
            <Route path="/ocio" element={<Ocio />} />
            <Route path="/avisos-movil" element={<AvisosMovil />} />
            <Route path="/archivo" element={<Archivo />} />
            <Route path="/familia" element={<Navigate to="/personas" replace />} />
            <Route path="/personas" element={<Familia />} />
            <Route path="/personas/:id" element={<PersonaDetalle />} />
            <Route path="/mascotas" element={<Mascotas />} />
            <Route path="/mascota/:id" element={<MascotaDetail />} />
            <Route path="/viviendas" element={<Viviendas />} />
            <Route path="/vivienda/:id" element={<ViviendaDetail />} />
            <Route path="/vehiculos" element={<Vehiculos />} />
            <Route path="/vehiculo/:id" element={<VehiculoDetail />} />
            <Route path="/area/:categoryId" element={<AreaView />} />
            <Route path="/asunto/:id" element={<MatterDetail />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/correos" element={<Correos />} />
            <Route path="/contactos" element={<Contactos />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <VisorDocumento />
      </DataProvider>
    </ProtectedRoute>
  );
}

function AppRouter() {
  const location = useLocation();
  // Callback de Google: procesa el session_id antes que cualquier ruta protegida.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/bienvenida" element={<PublicOnly><Bienvenida /></PublicOnly>} />
      <Route path="/privacidad" element={<AvisoPrivacidad />} />
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/registro" element={<PublicOnly><Register /></PublicOnly>} />
      <Route path="/recuperar" element={<Recuperar />} />
      <Route path="/restablecer" element={<Restablecer />} />
      <Route path="/verificar-email" element={<VerificarEmail />} />
      <Route path="/*" element={<AppShell />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
